import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import Icon from 'dpl/common/components/Icon';

const newsItems = [
  {
    quote:
      'Good Dog aims to connect people with the breed that best suits them, while avoiding support of puppy mills and storefront pet shops.',
    source: 'Newsweek'
  },
  {
    quote:
      'Good Dog vets dog breeders and rescue shelters for the consumer, only showing reliable and screened results.',
    source: 'Yahoo!'
  },
  {
    quote:
      'Good Dog helps people find the right four-footed addition for their family, by connecting them with reputable breeders, shelters and rescue groups.',
    source: 'Entrepreneur'
  },
  {
    quote:
      'Good Dog aims to help owners find sources for new pets that are healthy, humane, and trusted among the community.',
    source: 'Bustle'
  }
];

const CARDS_PER_PAGE = 1;

const SPLIDE_OPTIONS = {
  arrows: false,
  dragMinThreshold: 20,
  flickMaxPages: CARDS_PER_PAGE,
  flickPower: 300,
  gap: 16,
  keyboard: 'focused',
  pagination: false,
  perPage: CARDS_PER_PAGE,
  snap: true
};

export default function GoodDogNewsSection() {
  const splideRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const newsItemCount = newsItems.length;
  const isNextButtonDisabled = activeIndex >= newsItemCount - 1;
  const isPrevButtonDisabled = activeIndex <= 0;

  function handleActiveSlide(slide) {
    setActiveIndex(slide.index);
  }

  return (
    <div className="GoodDogNewsSection section-vertical-padding bg-peach-300">
      <div className="container-xl section-fade">
        <div className="GoodDogNewsSection__carousel">
          <Splide
            options={{
              ...SPLIDE_OPTIONS,
              drag: newsItems.length > 0,
              start: 0
            }}
            ref={splideRef}
            onActive={handleActiveSlide}
          >
            {newsItems.map(item => (
              <SplideSlide key={item.quote}>
                <div className="tc-ns">
                  <h3 className="font-28 md:font-40 mb4 mb8-md lh-title">
                    &ldquo;{item.quote}&rdquo;
                  </h3>
                  <p className="font-16 md:font-18 fw-medium">{item.source}</p>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
        <div className="mt10 mt12-md relative w-100" style={{ height: 2 }}>
          <span className="absolute bg-stone-700 db o-30 h-100 w-100" />
          <span
            className="absolute bg-stone-700 db h-100 transition"
            style={{
              width: `${(100 / newsItemCount) * (activeIndex + CARDS_PER_PAGE)}%`
            }}
          />
        </div>
        {newsItemCount > CARDS_PER_PAGE && (
          <div className="mt6 secondary">
            <button
              type="button"
              className={classnames('bg-white br-100 mr4', {
                'o-60': isPrevButtonDisabled
              })}
              disabled={isPrevButtonDisabled}
              onClick={() => splideRef.current.go('<')}
            >
              <div className="flex items-center justify-center ph3 pv3">
                <Icon name="fetch-arrow-left-md" />
              </div>
            </button>
            <button
              type="button"
              className={classnames('bg-white br-100', {
                'o-60': isNextButtonDisabled
              })}
              disabled={isNextButtonDisabled}
              onClick={() => splideRef.current.go('>')}
            >
              <div className="flex items-center justify-center ph3 pv3">
                <Icon name="fetch-arrow-right-md" />
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
